<template>
    <div class="content-wrap">
      <div class="register-wrap">
  
        <div class="row">
          <div class="col-md-3">
            <div class="mb-3">
              <ElLabel name="영업기회ID">
                <template #end="slotProps">
                  <ElInput :id="slotProps.id" v-model="state.salesOptyParams.sales_id" disabled placeholder="자동생성" />
                </template>
              </ElLabel>
            </div>
          </div>
          <div class="col-md-3">
            <div class="mb-3">
              <ElLabel name="End User" required>
                <template #end="slotProps">
                  <div class="input-group">
                    <ElInput :id="slotProps.id" v-model="state.salesOptyParams.end_user_cmp_nm" ref="endCmpNmRef" @click="openCmpModal({key : 'end_user_cmp',target :'sales'})" readonly />
                    <ElButton type="s-search" @click="openCmpModal({key : 'end_user_cmp',target :'sales'})"></ElButton>
                  </div>
                </template>
              </ElLabel>
            </div>
          </div>
          <div class="col-md-3">
            <div class="mb-3">
              <ElLabel name="매출처">
                <template #end="slotProps">
                  <div class="input-group">
                    <ElInput :id="slotProps.id" v-model="state.salesOptyParams.sales_cmp_nm" ref="salesCmpNmRef" @click="openCmpModal({key : 'sales_cmp',target :'sales'})" readonly />
                    <ElButton type="s-search" @click="openCmpModal({key : 'sales_cmp',target :'sales'})"></ElButton>
                  </div>
                </template>
              </ElLabel>
            </div>
          </div>
          <div class="col-md-3">
            <div class="mb-3" @click="openMngModal('manager1')">
              <ElLabel name="담당자1" required>
                <template #end="{id}">
                    <ElInput :id="id" v-model="state.salesOptyParams.manager1" ref="manager1Ref" :maxlength="10"/>
                </template>
              </ElLabel>
            </div>
          </div>
        </div>
  
        <div class="row">
          <div class="col-md-6">
            <div class="mb-3">
              <ElLabel name="영업기회명" required>
                <template #end="{id}">
                    <ElInput :id="id" v-model="state.salesOptyParams.sales_nm" ref="salesNmRef"/>
                </template>
              </ElLabel>
            </div>
          </div>
          <div class="col-md-3">
            <div class="mb-3">
              <ElLabel name="영업대표" required>
                <template #end="{id}">
                    <ElInput :id="id" v-model="state.salesOptyParams.sales_ceo" ref="salesCeoRef" readonly/>
                </template>
              </ElLabel>
            </div>
          </div>   
          <div class="col-md-3">
            <div class="mb-3" @click="openMngModal('manager2')">
              <ElLabel name="담당자2">
                <template #end="{id}">
                    <ElInput :id="id" v-model="state.salesOptyParams.manager2" ref="manager2Ref" :maxlength="10"/>
                </template>
              </ElLabel>
            </div>
          </div>           
        </div>
  
  
        <div class="row">
          <div class="col-md-3">
            <div class="mb-3">
              <ElLabel name="Bridge(B),Risk(R)">
                <template #end>
                  <SelectCode
                  ref="BRSelectRef"
                  :cd_gr="'BNR_CD'"
                  :matchCd="state.salesOptyParams.bnr_cd"
                  :hyphenIS="true"
                  @return="r=>state.salesOptyParams.bnr_cd = r.cd_id"
                />
                </template>
              </ElLabel>
            </div>
          </div>
          <div class="col-md-3">
            <div class="mb-3">
              <ElLabel name="Stage" required>
                <template #end>
                  <SelectCode
                  :cd_gr="'STG_CD'"
                  ref="stgSelectRef"
                  :matchCd="state.salesOptyParams.stage_cd"
                  @return="r=>state.salesOptyParams.stage_cd = r.cd_id"
                />
                </template>
              </ElLabel>
            </div>
          </div>    
          <div class="col-md-3">
            <div class="mb-3">
              <ElLabel name="우선협상자 선정일(Won Date)" required>
                <template #end>
                  <DatePicker
                    ref = "wonDateRef"
                    :selectDate="state.salesOptyParams.won_dt"
                    :max-date="state.salesOptyParams.po_dt"
                    @return="r=>state.salesOptyParams.won_dt = r"
                    />
                </template>
              </ElLabel>
            </div>
          </div>
          <div class="col-md-3">
            <div class="mb-3">
              <ElLabel name="PO발행일" required>
                <template #end>
                  <DatePicker
                    ref="poDateRef"
                    :selectDate="state.salesOptyParams.po_dt"
                    :min-date="state.salesOptyParams.won_dt"
                    @return="r=>state.salesOptyParams.po_dt = r"
                    />
                </template>
              </ElLabel>
            </div>
          </div>          
        </div>
        
        <div class="row">
          <div class="col-md-3">
            <div class="mb-3">
              <ElLabel name="매출세금계산서 발행일" required>
                <template #end>
                  <DatePicker
                    ref="taxRef"
                    :selectDate="state.inoutParams.tax_dt"
                    @return="r=>state.inoutParams.tax_dt = r"
                  />
                </template>
              </ElLabel>
            </div>
          </div>
          <div class="col-md-3">
            <div class="mb-3">
              <ElLabel name="발행여부" required>
                <template #end>
                  <SelectCode
                    ref="taxYnRef"
                    :cd_gr="'YN_CD'"
                    :matchCd="state.inoutParams.tax_yn"
                    @return="r=>state.inoutParams.tax_yn= getCancel(r)"
                  />
                </template>
              </ElLabel>
            </div>
          </div>      
          <div class="col-md-3">
            <div class="mb-3">
              <ElLabel name="수금일" required>
                <template #end>
                  <DatePicker
                    ref="collectRef"
                    :selectDate="state.inoutParams.collect_dt"
                    @return="r=>state.inoutParams.collect_dt = r"
                  />
                </template>
              </ElLabel>
            </div>
          </div>
          <div class="col-md-3">
            <div class="mb-3">
              <ElLabel name="수금여부" required>
                <template #end>
                  <SelectCode
                    ref="collectYnRef"
                    :cd_gr="'YN_CD'"
                    :matchCd="state.inoutParams.collect_yn"
                    @return="r=>state.inoutParams.collect_yn= r.cd_id"
                  />
                </template>
              </ElLabel>
            </div>
          </div>        
        </div>
        <div class="row">
          <div class="col-md-3">
            <div class="mb-3">
              <ElLabel name="최초 등록일">
                <template #end>
                  <DatePicker
                    :selectDate="state.salesOptyParams.reg_dt"
                    @return="r=>state.salesOptyParams.reg_dt = r"
                  />
                </template>
              </ElLabel>
            </div>
          </div>
          <div class="col-md-3">
            <div class="mb-3">
              <ElLabel name="고객PO#">
                <template #end="{id}">
                  <ElInput :id="id" classNm="form-control me-1" v-model="state.salesOptyParams.custom_po" onlyNumber :maxlength="17"/>
                </template>
              </ElLabel>
            </div>
          </div>
          <div class="col-md-3">
            <div class="mb-3">
              <ElLabel name="취소사유">
                <template #end="{id}">
                  <ElInput v-if="state.cancelflag"  :id="id" classNm="form-control me-1" readonly v-model="state.inoutParams.memo"  @click="clickMemoOpenDialog({key:'view' , target:state.inoutParams.memo,title,title :'매출세금 계산서 발행여부 취소사유'})"/>
                </template>
              </ElLabel>
            </div>
          </div>
        </div>
  
        <div class="row">
          <div class="col-md-3">
            <div class="mb-3">
              <ElLabel name="상품(납품)정보">
                <template #end="{id}">
                  <ElInput :id="id" v-model="state.salesOptyParams.prd_info" :maxlength="20"/>
                </template>
              </ElLabel>
            </div>
          </div>
          <div class="col-md-3">
            <div class="mb-3">
              <ElLabel name="납품완료일">
                <template #end="{id}">
                  <DatePicker
                    :selectDate="state.salesOptyParams.dlv_dt"
                    @return="r=>state.salesOptyParams.dlv_dt = r"
                  />
                </template>
              </ElLabel>
            </div>
          </div>
          <div class="col-md-3">
            <div class="mb-3">
              <ElLabel name="PSP 지정여부">
                <template #end="{id}">
                  <SelectCode
                :cd_gr="'YN_CD'"
                :matchCd="state.salesOptyParams.psp_yn"
                @return="r=>state.salesOptyParams.psp_yn = r.cd_id"
              />
                </template>
              </ElLabel>
  
            </div>
          </div>
          <div class="col-md-3">
            <div class="mb-3">
              <ElLabel name="검수완료일">
                <template #end="{id}">
                  <DatePicker
                    :selectDate="state.salesOptyParams.isp_dt"
                     :monthMinMaxDate="monthMinMaxDate"
                    @return="r=>state.salesOptyParams.isp_dt = r"
                  />
                </template>
              </ElLabel>
  
            </div>
          </div>
        </div>
  
        <div class="row">
          <div class="col-md-3">
            <div class="mb-3">
              <div class="form-check form-check-inline">
                <ElLabel name="갱신계약 영업기회 매핑">
                  <template #start="{ id }">
                    <ElCheckbox :id="id" v-model="state.warMapping" @checkboxChange="openOptyModal()" />
                    <ElCheckbox 
                      ref='optyModalBtn' 
                      data-bs-toggle="modal" 
                      data-bs-target="#optyModal" 
                      v-show="false"
                    />
                  </template>
                </ElLabel>
              </div>
              <ElInput ref="wSalesIdRef" v-model="state.salesOptyParams.w_sales_id" @inputClick="openOptyModal" readonly/>
            </div>
          </div>
          <div class="col-md-3">
            <div class="mb-3">
              <div class="form-check form-check-inline">
                <ElLabel name="계약만료일">
                  <template #start="{ id }">
                    <ElCheckbox 
                      :id="id" 
                      v-model="state.salesOptyParams.w_end_ck" 
                    />
                  </template>
                </ElLabel>
              </div>
              <DatePicker
              :selectDate="state.salesOptyParams.w_end_dt"
              :textable="true"
               :monthMinMaxDate="monthMinMaxDate"
              @return="r=>state.salesOptyParams.w_end_dt = r"
              />
            </div>
          </div>
          <div class="col-md-3">
            <div class="mb-3">
              <!--  활성화 클래스 btn-active -->
              <ElLabel name="즐겨찾기">
                <template #end="{ id }">
                  <ElButton 
                    :id="id"
                    type="bookmarkL"
                    :active="state.salesOptyParams.bkmark_yn === 'Y'"
                    @buttonClick="changeBkmark()"
                  >
                    즐겨찾기 추가
                  </ElButton> 
                </template>
              </ElLabel>
            </div>
          </div>
          <div class="col-md-3">
            <div class="mb-3">
              <ElLabel name="Aging(Days)">
                <template #end="{ id }">
                  <ElInput :id="id" v-model="aginng" readonly/>
                </template>
              </ElLabel>
            </div>
          </div>
        </div>
       
        <div class="row">
        <div class="col-md-3">
          <div class="mb-3">
            <ElLabel name="총 매출금액" required>
              <template #end="{id}">
                  <ElInput
                    :id="id"
                    :modelValue="priceToString(outcome_sum)"
                    @update:modelValue="r=>outcome_sum = r"
                    readonly
                  />
              </template>
            </ElLabel>
          </div>
        </div>
        <div class="col-md-3">
          <div class="mb-3">
            <ElLabel name="총 매입금액" required>
              <template #end="{id}">
                  <ElInput
                    :id="id"
                    :modelValue="priceToString(income_sum)"
                    @update:modelValue="r=>income_sum = r"
                    readonly
                  />
              </template>
            </ElLabel>
          </div>
        </div>
        <div class="col-md-3">
          <div class="mb-3">
            <ElLabel name="GM Amount" required>
              <template #end="{id}">
                  <ElInput
                    :id="id"
                    :modelValue="priceToString(gm_amt)"
                    @update:modelValue="r=>gm_amt = r"
                    readonly
                  />
              </template>
            </ElLabel>
          </div>
        </div>
        <div class="col-md-3">
          <div class="mb-3">
            <ElLabel name="GM%" required>
              <template #end="{id}">
                  <ElInput
                    :id="id"
                    :modelValue="priceToString(gm_amt_per)"
                    @update:modelValue="r=>gm_amt_per = r"
                    readonly
                  />
              </template>
            </ElLabel>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-md-12">
          <div class="mb-1">
            <ElLabel name="메모">
              <template #end="{id}">
                <ElInput :id="id" v-model="state.salesOptyParams.memo"/>
              </template>
            </ElLabel>
          </div>
        </div>
      </div>
      <div class="row">
          <Caption
            ref="captionRef"
            :tbId="state.captionTbId"
            :cap_seq="state.captionSeq"></Caption>
      </div>
    </div><!-- //register-wrap -->
  
      <div class="text-end py-3">
        <ElButton type="primary" v-if="!state.searchOptyParams.ims_seq" @buttonClick="checkValidation('C')">복사등록</ElButton>
        <ElButton type="primary" @buttonClick="router.push('/sr/MSR_SO_002')">이전</ElButton>
        <ElButton type="primary" v-if="!state.searchOptyParams.ims_seq" @buttonClick="checkValidation('Y')">임시저장</ElButton>
        <ElButton type="primary" @buttonClick="moveToPage('/mp/MMP_AM_001','임시저장함으로 이동하시겠습니까?')">임시저장함</ElButton>
        <ElButton type="primary"  @buttonClick="checkValidation('N')">수정완료</ElButton>
      </div>
  
      <div class="accordion" id="accordionPanelsStayOpenExample">
        <div class="accordion-item">
          <h2 class="accordion-header">
            <ElButton 
              type="accordionHeader" 
              target="panelsStayOpen-collapseOne"
            >
              매입처/상품 정보
            </ElButton>
          </h2>
          <div id="panelsStayOpen-collapseOne" class="accordion-collapse collapse">
            <div class="accordion-body accordion-body-register">
              
              <div class="search-wrap">
                <div class="row">
                  <div class="col-md-3">
                    <div class="mb-3">
                      <ElLabel name="매입처">
                        <template #end="{ id }">
                          <ElInput :id="id" v-model="state.searchParam.buy_cmp_info_nm" @inputKeyupEnter="searchInoutList()"/>
                        </template>
                      </ElLabel>
                      
                    </div>
                  </div>
                  <div class="col-md-3">
                    <div class="mb-3">
                      <ElLabel name="상품">
                        <template #end="{ id }">
                          <ElInput :id="id" v-model="state.searchParam.goods_nm" @inputKeyupEnter="searchInoutList()"/>
                        </template>
                      </ElLabel>
  
                    </div>
                  </div>                      
                </div>
              </div>
              <div class="search-detail-wrap"></div>
    
              <div class="text-end py-2">
                <ElButton type="search" @buttonClick="searchInoutList()">검색</ElButton>
              </div>
    
              <div class="d-flex justify-content-between">
                <div></div>
                <div class="table-btn-group d-flex align-items-center">
                  <ElButton type="excelDownload" @buttonClick="inoutExcelDown()">엑셀다운</ElButton>
                </div>
              </div>

              <div class="table-list">
                <DataTable
                  :value="state.searchInoutList"
                  paginator
                  :rows="10"
                  :rowsPerPageOptions="[10, 20, 50, 100, 200]"
                  editMode="cell"
                  @cell-edit-complete="onCellEditComplete" 
                  scrollable
                  :pt="{
                    wrapper : {style:'height : 600px'},
                    column: {
                        bodycell: ({ state }) => ({
                            class: [{ 'pt-0 pb-0': state['d_editing'] }]
                        })
                    }
                  }"
                >
                <template #empty>
                      <div>데이터가 존재하지 않습니다.</div>
                  </template>
                  <Column>
                    <template #header>
                      <ElCheckbox v-model="allCheck"/>
                    </template>
                    <template #body="{ data }">
                        <ElCheckbox 
                        v-model="state.inoutSelectedRow" 
                        :value="data"
                        />
                    </template>
                  </Column>
                  <template v-for="inout of state.inoutGridColumn" :key="inout.field">
                  <Column
                    v-if="inout.visible"
                    :key="inout.field"
                    :field="inout.field"
                    :header="inout.header"
                    :style = "inout.style"
                    :sortable ="inout.sortable"
                  >
                  <template #body="{data,field}">

                    <div v-if="field.includes('class_nm')"  class="class-nm" @click="openProdModal({key:field , target: 'inout',index :data.index})">
                      <span>{{ data[field]}}</span>
                    </div>

                    <div v-else-if="field == 'made_cmp_info_nm'" class="cmp-nm"  @click="openCmpModal({key:'made' , target: 'inout',index :data.index})">
                      {{ data[field]}}
                    </div>
  

                    <div v-else-if="field == 'buy_cmp_info_nm'" class="cmp-nm" @click="openCmpModal({key:'buy' , target: 'inout',index :data.index})">
                      {{ data[field]}}
                    </div>
                    

                    <div v-else-if="field == 'gm_amt'">
                      {{priceToString(data[field]) }}
                    </div>

                    <div v-else-if="field == 'gm_amt_per'">
                      {{data[field] }}
                    </div> 
                      

                    <div v-else-if="field.includes('sum')">
                      <span> {{ numberFomat(data[field])}} </span>
                    </div>
                    <div v-else-if="field ==='gpu_model_qty' && checkGPUModel(state.inoutRowData[data.index].prod_class_id) == true">
                      <span> {{ numberFomat(data[field]) }} </span>
                    </div>
                    <div v-else-if="field ==='gpu_model_nm' && checkGPUModel(state.inoutRowData[data.index].prod_class_id) == true">
                      <span> {{ getCodeNm(data[field]) }} </span>
                    </div>
                    <div v-else-if="field ==='gpu_model_nm' && 
                      checkGPUModel(state.inoutRowData[data.index].prod_class_id) == false"
                    >
                      <span> - </span>
                    </div>
                    <div v-else-if="field ==='gpu_model_qty' && 
                      checkGPUModel(state.inoutRowData[data.index].prod_class_id) == false"    
                    >
                      <span> - </span>
                    </div>

                    <div v-else>
                      {{ data[field] }}
                    </div>
                  </template>
  
                  <template #editor="{ data, field }">
                          <SelectCode
                            v-if="field == 'ins_yn' || field == 'tax_sale_yn' || field == 'purchase_yn' || field == 'pay_yn'|| field == 'collect_yn' || field == 'tax_yn'"
                            :cd_gr="'YN_CD'"
                            :matchCd="data[field]"
                            :focus="true"
                            @return="r=>data[field]= r.cd_id"
                          />
                          <SelectCode
                            v-else-if="field == 'gpu_model_nm' && checkGPUModel(state.inoutRowData[data.index].prod_class_id)"
                            :cd_gr="'GPU_MODEL_CD'"
                            :matchCd="data[field]"
                            :focus="true"
                            :chk_ess="'Y'"
                            :isShow="checkGPUModel(state.inoutRowData[data.index].prod_class_id)"
                            @return="(r) => (data[field] = r.cd_id)"
                          />
                          <!-- 매입매출 그룹 cell 클릭 블락 -->
                          <div v-else-if="field.includes('group')" :style="{ pointerEvents: 'none', opacity: 0.6 }" aria-disabled="true">
                            <span>{{ data[field] }}</span>
                          </div>
  
                          <div v-else-if="field.includes('class_nm')" class="class-nm" @click="openProdModal({key:field , target: 'inout',index :data.index})">
                            <span>{{ data[field]}}</span>
                          </div>
  
                          <!-- 제조사 cell 클릭시 모달 open-->
                          <div v-else-if="field == 'made_cmp_info_nm'" class="cmp-nm" @click="openCmpModal({key:'made' , target: 'inout',index :data.index})">
                            <span>{{ data[field]}}</span>
                          </div>
  
                          <!-- 매입처 cell 클릭시 모달 open-->
                          <div v-else-if="field == 'buy_cmp_info_nm'" class="cmp-nm" @click="openCmpModal({key:'buy' , target: 'inout',index :data.index})">
                            <span>{{ data[field]}}</span>
                          </div>

                          <div v-else-if="field === 'tax_dt'" style="width: 200px;">
                            <DatePicker
                              :selectDate="data[field]"
                              :max-date="state.inoutRowData[data.index].collect_dt ||  null"
                              @return="r=>data[field] = r"
                            />
                          </div>

                          <div v-else-if="field === 'collect_dt'" style="width: 200px;">
                            <DatePicker
                              :selectDate="data[field]"
                              :min-date="state.inoutRowData[data.index].tax_dt ||  null"
                              @return="r=>data[field] = r"
                            />
                          </div>

                          <div v-else-if="field === 'tax_sale_dt'" style="width: 200px;">
                            <DatePicker
                              :selectDate="data[field]"
                              @return="r=>data[field] = r"
                            />
                          </div>

                          <div v-else-if="field === 'pay_dt'" style="width: 200px;">
                            <DatePicker
                              :selectDate="data[field]"
                              @return="r=>data[field] = r"
                            />
                          </div>
                          
                          <div style="width: 200px;" v-else-if="field.includes('dt')">
                            <DatePicker
                            :selectDate="data[field]"
                            @return="r=>data[field] = r"
                          />
                          </div>
                          <div v-else-if="field ==='gpu_model_nm' && 
                            checkGPUModel(state.inoutRowData[data.index].prod_class_id) == false"
                          >
                            <span> - </span>
                          </div>
                          <div v-else-if="field ==='gpu_model_qty' && 
                            checkGPUModel(state.inoutRowData[data.index].prod_class_id) == false"
                          >
                            <span> - </span>
                          </div>
                          <ElInput v-else  v-model="data[field]"  autofocus :maxlength="17"/>
                  </template>
                  </Column>
                  </template>
                </DataTable>
              </div> 
              
              <div class="text-end py-3">
                <!-- 2025-03-27 
                <ElButton type="primary" @buttonClick="downTemplateInout()">매입매출 템플릿 다운로드</ElButton>
                <ElButton type="primary" @buttonClick="downloadCmpExcel()">회사 엑셀 다운로드</ElButton>
                <ElButton type="primary" @buttonClick="downloadProdExcel()">상품분류 엑셀 다운로드</ElButton>
                <ElButton type="primary" @buttonClick="selectUploadFile()">일괄등록</ElButton> -->
                <ElButton type="primary" @buttonClick="addInoutData()">추가</ElButton>
                <ElButton type="primary" @buttonClick="deleteInoutData()">삭제</ElButton>
              </div>
  
            </div>
          </div>
        </div>
      </div>
  
  
      <div class="accordion" id="accordionPanelsStayOpenExample">
        <div class="accordion-item">
          <h2 class="accordion-header">
            <ElButton type="accordionHeader" target="panelsStayOpen-collapseTwo" :active="state.resFileList.length > 0">
              첨부파일
            </ElButton>
          </h2>
          <div id="panelsStayOpen-collapseTwo" :class="[state.resFileList.length > 0 ?'accordion-collapse' : 'accordion-collapse collapse']">
            <div class="accordion-body accordion-body-register">
              <FileUpload
                ref="fileUploadRef"
                @return="res => getFileList(res)"
                @deleteData="res => getDeleteFile(res)"
              />
            </div>
          </div>
        </div>
      </div>     
      
      <!-- 영업기회 이력 조회 -->
      <OptyHistoryComponent/>
      <!-- 매입매출 이력 조회 -->
      <InoutHistoryComponent :maxRev="state.maxRev"/>
  
    </div>
      
      
      <!--상품 modal-->
      <ProdClassModal ref="prodClassModalRef" @return="r=>updateParam('prod',r)" :fs_year = "state.inoutParams.fs_year" :action_flag="'N'" :maxRev="state.maxRev"/>
      <!-- company modal -->
      <CompanyModal ref="companyModalRef" @return="r=>updateParam('company',r)"/>
  
      <!--warranty sales modal-->
      <WarrantySalesModal ref="warrantySalesModalRef" @return="r=>updateParam('opty',r)"/>
    <ElButton 
    ref="cmpModalBtnRef"
    data-bs-toggle="modal" 
    data-bs-target="#cmpModal" 
    v-show="false"/>
  
    <ElButton 
    ref="prodModalBtnRef"
    data-bs-toggle="modal" 
    data-bs-target="#prodModal" 
    v-show="false"/>
  
  
    <ExcelManage
      v-show="false"
      ref="excelManageRef"
      :headerKeys="state.excelHeaderKey"
      @return="r => getExcelData(r.sheets)"
    />

    <ManagerRegModal
      ref="managerRegModalRef"
      call-page="cp"
      @return="
        (r) => (  getMngData(r))
      "
    />
    <DialogText ref="DialogMemoTextRef" modal dismissableMask="false"
        @updateValue="handleUpdateMemoValue"
    />
  </template>
    
    
<script setup>   
import { reactive,onBeforeMount,ref,watch,computed,inject } from 'vue';

import FileUpload from '@/components/common/FileUpload.vue';
import DatePicker from '@/components/common/DatePicker.vue'
import SelectCode from '@/components/common/SelectCode.vue';
import Caption from '@/components/common/CaptionList.vue';
import routerCmn from '@/js/vueRouterCmn';
import DataTable from "primevue/datatable";
import Column from "primevue/column";

import common from "@/js/common";
import ExcelManage from '@/components/common/MCO_EX_001.vue';
import ProdClassModal from '@/components/common/modal/ProdClassModal.vue';
import CompanyModal from '@/components/common/modal/CompanyModal.vue';
import WarrantySalesModal from '@/components/common/modal/WarrantySalesModal.vue';
import ManagerRegModal from "@/components/common/modal/ManagerRegModal.vue";
import { useUserStore } from '@/store/user'
const userStore = useUserStore()
import { useCodeStore } from '@/store/code'

const codeStore = useCodeStore()
//공통코드 > api 코드

import { useLoading } from '@/composable/Loading.js'
const { setIsLoading } = useLoading()
import { salesOptyInoutList, salesOptyEdit, salesOptyInoutListEdit, salesOptySelect, salesOptyInoutListDel } from '@/api/sales';
import { getProdRevIdList, prodList ,depthProdList, getProdRevIDYearList} from '@/api/prod';
import { compList } from '@/api/comp';
import DialogText from '@/components/common/modal/DialogText.vue'

import { fileList } from '@/api/file';
import { router } from '@/router';
import { cpCtntDel, cpCtntSelect } from '@/api/capr';
import InoutHistoryComponent from './components/InoutHistoryComponent.vue';
import OptyHistoryComponent from './components/OptyHistoryComponent.vue';

const fileUploadRef = ref()
const cmpModalBtnRef = ref()
const salesCmpNmRef = ref()
const endCmpNmRef = ref()
const manager1Ref = ref()
const manager2Ref = ref()
const salesNmRef = ref()
const optyModalBtn = ref()
const prodModalBtnRef = ref()
const excelManageRef = ref()
const captionRef = ref()
const salesCeoRef = ref()
const prodClassModalRef = ref()
const companyModalRef = ref()
const warrantySalesModalRef = ref()
const wonDateRef = ref()
const poDateRef = ref()
const stgSelectRef = ref()
const taxRef = ref()
const taxYnRef = ref()
const collectRef = ref()
const collectYnRef = ref() 
const wSalesIdRef = ref()
const managerRegModalRef = ref()
const DialogMemoTextRef = ref()
const BRSelectRef = ref()
const selectRowIndex = reactive({
  index : 0
})


const allCheck = computed({
    get(){
      return state.searchInoutList.length === state.inoutSelectedRow.length;
    },
    set(newValue){
      state.inoutSelectedRow = newValue ? state.searchInoutList.map((item)=>{return item}) : [];
    }
})
  

const handleUpdateMemoValue = (value) =>{
  state.inoutParams.memo = value
}

const checkGPUModel = (val)=>{
  return state.gpu_model_prod_list.some((r) =>{
    if(r.class_Id == val){
      return true
    }else{
      return false
    }
  })
}

const outcome_sum = computed(()=>{
  let outcome_sum = 0
  state.inoutRowData.forEach((item)=>{
    if(item.outcome_sum){
      item.outcome_sum = typeof item.outcome_sum === 'string' ?  item.outcome_sum.replaceAll(',','') : item.outcome_sum
      outcome_sum += Number(item.outcome_sum)
    }
  })
  return isNaN(outcome_sum) ? 0 : outcome_sum
})


const income_sum = computed(()=>{
  let income_sum = 0
  state.inoutRowData.forEach((item)=>{
    if(item.income_sum){
      item.income_sum = typeof item.income_sum === 'string' ?  item.income_sum.replaceAll(',','') : item.income_sum
      income_sum += Number(item.income_sum)
    }
  })
  return isNaN(income_sum) ? 0 : income_sum
})

const gm_amt = computed(()=>{
  let outcome_sum_val = Number(outcome_sum.value)
  let income_sum_val = Number(income_sum.value)

  let gm_amt =  outcome_sum_val - income_sum_val 
  return isNaN(Number(gm_amt)) ? 0 : gm_amt // Number(gm_amt)
})


const gm_amt_per = computed(()=>{
  let outcome_sum_val = Number(outcome_sum.value)
  let gm_amt_value = Number(gm_amt.value)

  let gm_amt_per = (gm_amt_value / outcome_sum_val * 100).toFixed(1)
  return isFinite(Number(gm_amt_per)) ? Number(gm_amt_per): 0 
})

//매출세금 계산서 Y로 변경 && stage commit,won,close
const monthMinMaxDate = computed(()=>{
  if(state.depthProdList && state.inoutRowData){
    const yList = state.depthProdList.filter(r => r.applicable_yn == 'Y' || r.applicable_yn == 'A')
    const applicableYn = checkApplicableLists(yList,state.inoutRowData)
    if(state.inoutParams.tax_dt && state.inoutParams.tax_yn ==='Y' && (state.salesOptyParams.stage_cd.includes('STG03') ||
             state.salesOptyParams.stage_cd.includes('STG04') ||
             state.salesOptyParams.stage_cd.includes('STG05')) && !applicableYn.isApplicable && !applicableYn.hasAMatch){ 
      return state.inoutParams.tax_dt
    }
  }
})

const checkApplicableLists = (aList, bList) => {
    let hasAMatch = false; 
    let firstYProductName = null; 
    let firstAProductName = null; 

  
    const bClassIds = new Set(bList.map(item => item.prod_class_id));
    for (const aItem of aList) {
        if (bClassIds.has(aItem.class_Id)) {
            if (aItem.applicable_yn === 'A') {
                hasAMatch = true;
                if (!firstAProductName) { 
                    firstAProductName = aItem.class_nm;
                }
            } else if (aItem.applicable_yn === 'Y') {
              
                if (!firstYProductName) {
                    firstYProductName = aItem.class_nm;
                }
            }
        }
    }
    if (hasAMatch || firstYProductName) {
        return {
            isApplicable: false,
            productName: hasAMatch ? firstAProductName : firstYProductName,
            hasAMatch: hasAMatch 
        };
    } else {
        return {
            isApplicable: true,
            productName: null,
            hasAMatch: false
        };
    }
};
onBeforeMount(async()=>{
  //상세조회
  let param = history.state;
  if(param.ims_seq){
    state.searchOptyParams.ims_seq = param.ims_seq
    state.searchOptyParams.opty_seq = null
    state.searchOptyParams.sales_id = null
  }else if(param.opty_seq){
    state.searchOptyParams.opty_seq = param.opty_seq
    state.searchOptyParams.sales_id = param.sales_id
    state.searchOptyParams.ims_seq = null
    state.maxRev = param.prod_rev_id
  }else{
    alert('잘못된 접근입니다.')
    router.go(-1)
  }
  
  await searchOpty()
  await getList2();
  await getInoutList()

  getGMandGMper();
  searchInoutList();

})
  
  //aginng (날짜차이 계산)
  const aginng = computed(()=>{
    let today = new Date();
    let diffDate =null;
    if(state.salesOptyParams.reg_dt != null){
      diffDate = Math.abs((today - new Date(state.salesOptyParams.reg_dt).getTime()) / (1000 * 60 * 60 * 24));
    }
    return diffDate ? Math.floor(diffDate) : 0 // 밀리세컨 * 초 * 분 * 시 = 일
  })
  
  
  const state = reactive({
    inoutMaxIndex : 0,
    maxRev : '',
    resFileList : [],
    searchOptyParams : {
      opty_seq : null,
      sales_id : null,
      ims_seq : null,
    },
    saveType : '',
    captionTbId : 'sales',
    captionSeq : null,
    inoutParams: {
      tax_dt : '',
      tax_yn : '',
      collect_dt : '',
      collect_yn : '',
      memo : '',
      memo_yn : '',
      fs_year:''
    },
    cancelflag : false,
    salesOptyParams :{
      opty_seq : null,
      iopty_seq : null,
      sales_id : null,                //영업기회id
      ims_seq : null,
      sales_cmp_info_seq : '',      //매출처(회사관리번호로 관리)
      sales_cmp_nm : '',            //매출처이름
      end_user_cmp_info_seq : '',             //endUser(회사관리번호로 관리)
      end_user_cmp_nm : '',             //endUser이름
      employee_id : userStore.user.employeeId,
      manager1 : '',                //담당자1
      manager2 : '',                //담당자2
      sales_nm : '',                //영업기회명
      sales_ceo : userStore.user.userNm ? userStore.user.userNm : '',               //영업대표
      maker_cmp_info_seq : '',                //제조사(회사관리번호로 관리)
      maker_cmp_nm : '',                //제조사이름
      stage_cd : '',                //stage(공통코드)
      bnr_cd : '',                  //Bridge&Risk(공통코드)
      tax_dt : '',                 //매출세금계산서 발행일(일자)
      collect_dt : '',              //수금일(일자) 
      tax_yn : '',                  //발행여부
      collect_yn : '',              //수금여부
      reg_dt : '',              //최초 등록일
      won_dt : '',                 //우선협상자 선정일(일자)
      po_dt:'',                     //po발행일
      custom_po : null,               //고객PO
      prd_info : '',                //상품(납품)정보
      dlv_dt : '',                  //납품완료일
      psp_yn : '',                  //PSP지정여부
      isp_dt : '',                  //검수완료일(일자)
      w_sales_id : '',              //Warranty 영업기회 매핑 id
      w_end_dt : '',                //Warranty End Date(일자)
      w_end_ck : false,                //Warranty End Date 체크(1:체크)
      w_alarm_yn : '',
      ngt_date : '',
      bkmark_yn : 'N',               //즐겨찾기
      memo : '',                    //메모
      outcome_sum : 0,              //총매출금액
      income_sum : 0,               //총매입금액
      gm_amt : 0,                  //GM AMT(매출-매입)
      gm_amt_per : 0,               //GM Amt/매출
      tmp_yn : 'N',
      cap_seq : 0,
      tb_id : 'sales',
      depthProdList : [],
      attachFileVO: {
        file_div_id: "10",
        file_seq: "", //추가 된 파일 seq 전송
        del_file_seq: "", // 삭제해야 할 파일 seq 전송
      },
      upd_yn : 'N'
    },
    originalSalesOptyParams : {},
    excelGridColumn1: [
      {header: "상품",rowspan : 1,colspan : 3},
      {header: "리비전번호",rowspan : 2,colspan : 1},
      {header: "상품ID",rowspan : 2,colspan : 1},
      { header: "활성화 여부",rowspan : 2,colspan : 1},
    ],
    prodList: [],
    excelData : [],
    //파일 첨부 데이터()
    fileList: [],
    delFileList: [],
    searchParam:{
      buy_cmp_info_nm :'',
      goods_nm:''
    },
    prodCodeLev : 3,
    clickKey : {
      key : '',
      target : '',
      index : null
    }, 
    warMapping : false,
    prodRevId : '',
    tax_dt_s : '',
    tax_dt_e : '',
    gpu_model_prod_list:[],
    inoutGridMainCtgy : [
      {header : '제조사', rowspan:2,colspan:1,style:{minWidth : '180px'}},
      {header : '매입처', rowspan:2,colspan:1,style:{minWidth : '180px'}},
      {header : '상품' , rowspan:1,colspan:3,style:{textAlign : 'center',minWidth : '200px'}},
  
      {header : '매출금액(원)' , rowspan:2,colspan:1,style:{textAlign : 'right',minWidth : '140px'}},
      {header : '매입금액(원)' , rowspan:2,colspan:1,style:{textAlign : 'right',minWidth : '140px'}},
  
      {header : '매출세금계산서 발행일' , rowspan:2,colspan:1,style:{textAlign : 'center',minWidth : '105px'}},
      {header : '발행여부' , rowspan:2,colspan:1,style:{textAlign : 'center',minWidth : '50px'}},
      
      {header : '수금일' , rowspan:2,colspan:1,style:{textAlign : 'center',minWidth : '110px'}},
      {header : '수금여부' , rowspan:2,colspan:1,style:{textAlign : 'center',minWidth : '50px'}},
  
      {header : '매입세금계산서 발행일' , rowspan:2,colspan:1,style:{textAlign : 'center',minWidth : '110px'}},
      {header : '매입여부' , rowspan:2,colspan:1,style:{textAlign : 'center',minWidth : '50px'}},
      {header : '지급일' , rowspan:2,colspan:1,style:{textAlign : 'center',minWidth : '110px'}},
      {header : '지급여부' , rowspan:2,colspan:1,style:{textAlign : 'center',minWidth : '50px'}}
    ],
  
    inoutGridSubCtgy : [
      {header : '1단계', field : 'class_nm1'},
      {header : '2단계', field : 'class_nm2'},
      {header : '3단계', field : 'class_nm3'},
    ],
    inoutGridColumn: [
{ header: "제조사",field : 'made_cmp_info_nm', style: {minWidth:'120px'}, sortable:true, visible:true},
    { header: "매입처",field : 'buy_cmp_info_nm', style: {minWidth:'120px'}, sortable:true, visible:true},
    { header: "상품1단계", field: 'class_nm1', style: { minWidth: '100px' }, sortable: true, visible:true },
    { header: "상품2단계", field: 'class_nm2', style: { minWidth: '100px' }, sortable: true, visible:true },
    { header: "상품3단계", field: 'class_nm3', style: { minWidth: '100px' }, sortable: true, visible:true },
    { header: "GPU Model", field: 'gpu_model_nm', style: { minWidth: '100px' }, sortable: true, visible: false },
    { header: "GPU 수량", field: 'gpu_model_qty', style: { textAlign : 'right',minWidth: '120px' }, sortable: true, visible: false},
    { header: "매출금액(원)", field : 'outcome_sum', style: {textAlign : 'right', minWidth:'120px'}, sortable:true, visible:true},
    { header: "매입금액(원)",field : 'income_sum', style: {textAlign : 'right', minWidth:'120px'}, sortable:true, visible:true},
    { header: "Gross Margin",field : 'gm_amt', style: {textAlign : 'right', minWidth:'140px'}, sortable:true, visible:true},
    { header: "GM(%)",field : 'gm_amt_per', style: {textAlign : 'center', minWidth:'70px'}, sortable:true, visible:true},
    // 2025-03-27
    // { header: "매출세금계산서 발행일", field : 'tax_dt', style: {textAlign : 'center', minWidth:'140px'}, sortable:true},
    // { header: "발행여부",field : 'tax_yn', style: {textAlign : 'center', minWidth:'70px'}, sortable:true},
    // { header: "수금일", field : 'collect_dt', style: {textAlign : 'center', minWidth:'140px'}, sortable:true},
    // { header: "수금여부", field : 'collect_yn', style: {textAlign : 'center', minWidth:'70px'}, sortable:true},

    { header: "매입세금계산서 발행일", field : 'tax_sale_dt', style: {textAlign : 'center', minWidth:'140px'}, sortable:true, visible:true},
    { header: "매입여부", field : 'tax_sale_yn', style: {textAlign : 'center', minWidth:'70px'}, sortable:true, visible:true},
    { header: "지급일",field : 'pay_dt', style: {textAlign : 'center', minWidth:'140px'}, sortable:true, visible:true},
    { header: "지급여부", field : 'pay_yn', style: {textAlign : 'center', minWidth:'70px'}, sortable:true, visible:true},
    ],
    inoutRowData : [],
    inoutSearchRowData : [],
    inoutSelectedRow : [],
    searchInoutList : [],
    originalInoutRowData : [],
    successCnt : 0,
    recentProdRev : '',
    pageType : 'insert',
    typeName : '',
    excelHeaderKey : [
      'made_cmp_info',
      'buy_cmp_info',
      'class_id',
      'outcome_sum',
      'income_sum',
      'tax_dt',
      'tax_yn',
      'collect_dt',
      'collect_yn',
      'tax_sale_dt',
      'tax_sale_yn',
      'pay_dt',
      'pay_yn',
    ],
    salesOptyInoutListVO : [],
    inoutKey : [
      'made_cmp_info_nm',
      'buy_cmp_info_seq',
      'buy_cmp_info_nm',
      'made_cmp_info_seq',
      'prod_class_id',
      'income_sum',
      'outcome_sum',
      'gpu_model_nm',
      'gpu_model_qty'
    ],
    optyInoutGroupList : [],
    groupName : '',
    gpumodelYn: false,
  })
  
  
watch(
  () => state.inoutRowData.length,(newVal,oldVal)=>{
    searchInoutList()
  },
)

watch(
  () => state.searchParam.buy_cmp_info_nm,(newVal,oldVal)=>{
    searchInoutList()
  },
)

watch(
  () => state.searchParam.goods_nm,(newVal,oldVal)=>{
    searchInoutList()
  },
)

watch(
  () => state.salesOptyParams.bnr_cd,(newVal,oldVal)=>{
    if(state.salesOptyParams.bnr_cd && state.salesOptyParams.bnr_cd !==''){
      if(state.salesOptyParams.bnr_cd == 'BNR03'){
        if(state.salesOptyParams.stage_cd !=='STG03'&& state.salesOptyParams.stage_cd !=='STG06'&& state.salesOptyParams.stage_cd !=='STG07'){
          alert('Bridge(B),Risk(R)의 Risk는 Stage가 Commit(Lost,Omit)일때 가능합니다.\n')
          state.salesOptyParams.bnr_cd = ''
          BRSelectRef.value.nullDefault();
          BRSelectRef.value.focus();
        }
      }else if(state.salesOptyParams.bnr_cd== 'BNR02'){
        if(state.salesOptyParams.stage_cd !=='STG02' && state.salesOptyParams.stage_cd !=='STG06' && state.salesOptyParams.stage_cd !=='STG07'){
          alert('Bridge(B),Risk(R)의 Bridge는 Stage가 Upside(Lost,Omit)일때 가능합니다.\n')
          state.salesOptyParams.bnr_cd = ''
          BRSelectRef.value.nullDefault();
          BRSelectRef.value.focus();
        }
      }
    }
  },
)

watch(
  ()=>state.salesOptyParams.stage_cd,(newVal,oldVal)=>{
    if(state.salesOptyParams.stage_cd && state.salesOptyParams.stage_cd !==''){
      if(state.salesOptyParams.bnr_cd == 'BNR03'){
        if(state.salesOptyParams.stage_cd !=='STG03'&& state.salesOptyParams.stage_cd !=='STG06'&& state.salesOptyParams.stage_cd !=='STG07'){
          alert('Bridge(B),Risk(R)의 Risk는 Stage가 Commit(Lost,Omit)일때 가능합니다.\n')
          state.salesOptyParams.stage_cd = ''
          stgSelectRef.value.nullDefault();
          stgSelectRef.value.focus();
        }
      }else if(state.salesOptyParams.bnr_cd== 'BNR02'){
        if(state.salesOptyParams.stage_cd !=='STG02' && state.salesOptyParams.stage_cd !=='STG06' && state.salesOptyParams.stage_cd !=='STG07'){
          alert('Bridge(B),Risk(R)의 Bridge는 Stage가 Upside(Lost,Omit)일때 가능합니다.\n')
          state.salesOptyParams.stage_cd = ''
          stgSelectRef.value.nullDefault();
          stgSelectRef.value.focus();
        }
      }
    }
  },
)

watch(
  () => state.inoutParams.tax_dt,
    (newVal,oldVal) => {
      if(oldVal && newVal.slice(0,4) !== oldVal.slice(0,4)){
        alert("매출회계연도가 변경되었으니,\n 상품분류의 회계연도가 맞는지 확인하세요")
        getProdRevId();
        state.inoutParams.fs_year = state.inoutParams.tax_dt.substring(0,4)
      }
    }
)


const getList2 = async () => {
  // const revRes = await getProdRevIdList()
  // revRes.rtn.forEach((item)=>{
  //   if(item.rev_id > state.maxRev) state.maxRev = item.rev_id
  // })

  let params = {
    rev_id: state.maxRev, // 리비전 ID 필수값
  };
  try {
    const res = await depthProdList(params)
    state.depthProdList = [...res.rtn]
    state.gpu_model_prod_list = state.depthProdList.filter(r=> r.gpu_model_yn ==='Y')
    return [...res.rtn]
  } catch (err) {
    console.error(err)
  } finally {

  }
};
  
//매입매출정보 조회
const getInoutList = async()=>{
  try{
    setIsLoading(true)
    //상품 조회 코드 추가하기
    
    let searchParams = {
      opty_seq:state.searchOptyParams.opty_seq,
      sales_id : state.searchOptyParams.sales_id,
      buy_cmp_info_nm : state.searchParam.buy_cmp_info_nm,
      ims_seq:state.searchOptyParams.ims_seq,
    }

    const res = await salesOptyInoutList(searchParams)
    let resList = [...res.rtn]
    state.maxRev = resList[0]?.prod_rev_id

    const prodRes = await prodList({rev_id : state.maxRev})
    let prodResList = [...prodRes.rtn]
    state.inoutRowData = resList.map((item)=>{
      item.index = state.inoutMaxIndex
      state.inoutMaxIndex += 1
      Object.keys(item).forEach((key)=>{
        if(key.includes('_dt')){
          if(item[key] !== '19000101'){
            item[key] = item[key] || 'N/A'
          }else{
            item[key] = 'N/A'
          }
        }

        if(key.includes('_yn') && item[key] === 'A'){
          item[key] = 'N/A'
        }

        if(key == 'tax_dt'){
          state.inoutParams.tax_dt = item[key]
          state.inoutParams.fs_year = item[key].substring(0,4)
        }

        if(key == 'collect_dt'){
          state.inoutParams.collect_dt = item[key]
        }
        
        if(key == 'memo'){
          state.inoutParams.memo = item[key]
        }

        if(key == 'tax_yn'){
          state.inoutParams.tax_yn = item[key]
        }

        if(key == 'collect_yn'){
          state.inoutParams.collect_yn = item[key]
        }

        if (key == 'opty_inout_seq') {
            item['group'] = setGroupName(item, key)
        }
        if(key == 'prod_class_id'){
          const hasAnyGpuModel = resList.some(item => 
            state.gpu_model_prod_list.some(gpu => gpu.class_Id === item.prod_class_id)
          );
          state.gpumodelYn = hasAnyGpuModel;
          state.inoutGridColumn.forEach(column => {
            if (column.field === 'gpu_model_nm' || column.field === 'gpu_model_qty') {
                column.visible = hasAnyGpuModel;
            }
          });
        }
      })

      let codeFam = common.findUperCode(item.prod_class_id,prodResList) || []
      item.prod_level = codeFam.length
      let flag = true

      if(state.searchParam.goods_nm){
        codeFam.forEach((codeItem)=>{
          let codeNm = codeItem.class_nm.toLowerCase()
          if(!codeNm.includes(state.searchParam.goods_nm.toLowerCase())){
            flag = false
          }
        })
      }

      if(flag) {
        codeFam.forEach((codeItem,index)=>{
          item[`class_nm${index+1}`] = codeItem.class_nm
        })
        //createInoutCol(codeFam)
        return item
      }
    })

    state.originalInoutRowData = state.inoutRowData.map(item => ({ ...item }));
  } catch(err) {
    console.error(err)
  } finally {
    setIsLoading(false)
  }
}

//매입매출정보 검색
async function searchInoutList(){
  let searchList = [...state.inoutRowData]
  //매입매출 원본 리스트에서 매입처, 상품이름 검색 filter 로직
  searchList = state.inoutRowData.filter((item)=>{
    let flag = true
    
    //매입처 이름 조건 filter
    if(state.searchParam.buy_cmp_info_nm){
      flag = item.buy_cmp_info_nm ? item.buy_cmp_info_nm.includes(state.searchParam.buy_cmp_info_nm) : false
      //flag false면 아래로직까지 가지말고 거르기
      if(!flag) return
    }

    //상품 이름 검색 (뎁스가 어디까지 늘어날지몰라 모든 뎁스 유사어 있으면 검색리스트 추가)
    if(state.searchParam.goods_nm){
      //검색어가 있고 prod_level이 없는 경우 검색 제외
      //prod_level은 일괄등록, 매입매출 상품 적용할때(updateParam 함수 참조) 추가됨
      if(item.prod_level){
        for(var i=1; i<=item.prod_level; i++){
          let classNm = item[`class_nm${i}`].toLowerCase()
          flag = classNm ? classNm.includes(state.searchParam.goods_nm.toLowerCase()) : false
          if(flag) break;
        }
      }else{
          flag = false
      }
    }

    

    if(flag){
      return item
    }
  })
 
  state.searchInoutList = searchList || []
}


const getOptionStyle = (item) => {
  const stageValue = item
  let classNm = ''
  if (stageValue == 'Y') {
    classNm = 'stage stage-close';
  } else if (stageValue == 'N') {
    classNm = 'stage stage-omit';
  }
  return classNm
}

const getGMandGMper = (list) => {

  let inoutRowDataList = state.inoutRowData
  inoutRowDataList.map((item,index) =>{
    
    let a = Number(item.income_sum)
    let b = Number(item.outcome_sum)

    item['gm_amt'] = b - a
    const gm_amt_per = item['gm_amt'] / Number(item['outcome_sum']) * 100
    item['gm_amt_per']= `${Math.round(isFinite(Number(gm_amt_per)) ? Number(gm_amt_per): 0 )}%`
  })
  state.inoutRowData = inoutRowDataList
  
  
// if(field === 'outcome_sum' || field === 'income_sum'){
//       data['gm_amt'] = Number(newData['outcome_sum']) - Number(newData['income_sum'])
//       data['gm_amt_per'] = data['gm_amt'] / Number(newData['outcome_sum']) * 100
//     }
}

//북마크 체크시 실행 함수
const changeBkmark =()=>{
  if(state.salesOptyParams.bkmark_yn === 'Y'){
    state.salesOptyParams.bkmark_yn = 'N'
  }else{
    state.salesOptyParams.bkmark_yn = 'Y'
  }
}
  
  
const getFileList = (res) =>{
  if (res && res?.length > 0) {
    res.forEach((file) => {
      state.fileList.push(file.file_seq);
    });
  }
  saveOpty();

}

const getDeleteFile = (res) =>{
  state.delFileList.push(res.file_seq);
}


// const moveToPage = (url)=>{
//   routerCmn.routerPush(url)
// }

const openMngModal = (key) =>{
  state.clickKey.key = key
  managerRegModalRef.value.openModal()
}

const openCmpModal = (val) =>{
  state.clickKey.key = val.key
  state.clickKey.target = val.target
  state.clickKey.index = val.index
  companyModalRef.value.openModal()
}
  
//모달 선택버튼으로 닫혔을 경우 선택값 update
//회사,영업기회,상품분류 모달
const updateParam = (type,returnData) =>{
  if(!returnData) return


  if(type === 'company'){
    //매출처,end_user,제조사 매핑

    let companyDeptName = returnData.cmp_dvsn_nm ? `${returnData.cmp_nm}(${returnData.cmp_dvsn_nm})` : `${returnData.cmp_nm}`

    if(state.clickKey.target === 'sales'){
      state['salesOptyParams'][`${state.clickKey.key}_nm`] = companyDeptName
      state.salesOptyParams[`${state.clickKey.key}_info_seq`] = returnData.cmp_info_seq
    }
    //매입매출처 정보 > 제조사,매입처 매핑
    else if(state.clickKey.target === 'inout'){
      state.inoutRowData.some((item)=>{
        if(item.index === state.clickKey.index){
          item[`${state.clickKey.key}_cmp_info_nm`] = companyDeptName // `${returnData.cmp_nm}(${returnData.cmp_dvsn_nm})`
          item[`${state.clickKey.key}_cmp_info_seq`] = returnData.cmp_info_seq
          return true
        }
      })
    }
    
    state.clickKey = {key : '',target : ''}

  }else if(type == 'opty'){

    state.salesOptyParams.w_sales_id = returnData.sales_id

  }else if(type == 'prod'){
    //선택한 행이 있는 경우 (returnData : 선택한 행 데이터)

    if(returnData.codeFam.length>0){

      //기존 단계별 class_nm을 ''으로 설정
      state.inoutRowData.some((item)=>{
        if(item.index === state.clickKey.index){
          Object.keys(item).forEach((key)=>{
            if(key.includes('class_nm')){
              item[key] = ''
            }
          })
          returnData.codeFam.forEach((code,index)=>{
            item[`class_nm${index+1}`] = code['class_nm']
          })

          item['prod_rev_id'] = returnData.rev_id
          item.prod_class_id = returnData.selectKey
          item.prod_level = returnData.codeFam.length
          //현재 보여지는 단계보다 높을경우 inout 그리드 상품 단계 컬럼 추가
          //createInoutCol(returnData.codeFam)
          
          return true
        }
      })
      const hasAnyGpuModel = state.inoutRowData.some(item => 
        state.gpu_model_prod_list.some(gpu => gpu.class_Id === item.prod_class_id)
      );
      state.gpumodelYn = hasAnyGpuModel;
      state.inoutGridColumn.forEach(column => {
        if (column.field === 'gpu_model_nm' || column.field === 'gpu_model_qty') {
            column.visible = hasAnyGpuModel;
        }
      });

    }
  }
 
  searchInoutList()
} 

  const checkValidation = async(tmpYn) =>{
    try{
    let msg = codeStore.getCodeMsg("77777");
    state.salesOptyParams.tmp_yn = tmpYn

    if(tmpYn === 'N'){
      if (!state.salesOptyParams.end_user_cmp_info_seq.trim() || !state.salesOptyParams.end_user_cmp_nm.trim()) {
        //endUser
        endCmpNmRef.value.input.focus()
        alert(msg);
        return;
      }
      
      if (!state.salesOptyParams.sales_cmp_info_seq.trim() || !state.salesOptyParams.sales_cmp_nm.trim()) {
        //매출처
        salesCmpNmRef.value.input.focus()
        alert(msg);
        return;
      }

      if (!state.salesOptyParams.manager1.trim()) {
        //담당자1
        manager1Ref.value.input.focus()
        alert(msg);
        return;
      }

      if (state.salesOptyParams.manager2.length > 10  || state.salesOptyParams.manager1.length > 10) {
        //담당자1
        // manager1Ref.value.input.focus()
        alert('담당자 10자 이하만 가능합니다.');
        return;
      }

      if (!state.salesOptyParams.sales_nm.trim() || state.salesOptyParams.sales_nm.length > 100) {
        //영업기회명
        salesNmRef.value.input.focus()
        alert(msg);
        return;
      }


      if (!state.salesOptyParams.sales_ceo.trim()) {
        //영업대표
        salesCeoRef.value.input.focus()
        alert(msg);
        return;
      }
      
      //stage 
      if(!state.salesOptyParams.stage_cd){
        stgSelectRef.value.focus()
        alert('stage를 선택해주세요')
        return
      }

      
      if (!state.salesOptyParams.won_dt) {
        //wonDateRef.value.focus()
        //우선협상자 선정일
        alert('우선협상자 선정일(Won Date)을 입력하세요')
        return;
      }

      if (!state.salesOptyParams.po_dt) {
        //PO 발행일
        alert('PO발행일을 입력하세요')
        return;
      }

      //매출세금계산서 발행일
      if(!state.inoutParams.tax_dt){
        alert('매출세금계산서 발행일을 입력하세요')
        return;
      }

      //발행여부 
      if(!state.inoutParams.tax_yn){
        taxYnRef.value.focus()
        alert('발행여부를 선택하세요')
        return;
      }
      
      //수금일
      if(!state.inoutParams.collect_dt){
        alert('수금일을 입력하세요')
        return;
      }

      //수금여부 
      if(!state.inoutParams.collect_yn){
        collectYnRef.value.focus()
        alert('수금여부를 선택하세요')
        return;
      }

      if(state.salesOptyParams.custom_po){
        if (isNaN(Number(state.salesOptyParams.custom_po)) || state.salesOptyParams.custom_po.length > 19) {
          alert('고객PO#는 19자리이하 숫자만 가능합니다.')
          return;
        }
      }
      

      if(state.warMapping && !state.salesOptyParams.w_sales_id){
        alert('매핑할 Warranty 영업기회를 선택해주세요.')
        wSalesIdRef.value.input.focus()
        return
      }

      if( state.salesOptyParams.w_end_ck == true){
          if(state.salesOptyParams.w_end_dt == null || state.salesOptyParams.w_end_dt ==undefined || state.salesOptyParams.w_end_dt == ""){
            alert('Warranty End Date를 입력하세요')
            return
          }
        }

      let res = await captionRef.value.checkValidation()
      if(!res){
        return
      }

      // 2024-10-11 고객 요청사항 반영
      //  if(outcome_sum.value ===0 && income_sum.value === 0){
      //    alert('총 매출금액,매입금액의 값이 없습니다.매입 매출처 정보를 입력해주세요.')
      //    return
      //  }

      let prodFlag = false
      let warnMsg = '매입매출처 정보는 모두 필수값입니다.'
      state.inoutRowData.some((item)=>{
        state.inoutKey.some((key)=>{
          if(key === 'prod_class_id' && item['prod_class_id']?.length !== 12){
            warnMsg = '매입매출 상품분류를 3단계로 선택해주세요.'
            prodFlag = true
          return prodFlag
          }
          else if(key === 'made_cmp_info_nm' && !item[key]){
            warnMsg = '제조사를 입력해주세요.'
            prodFlag = true
          return prodFlag
          }
          else if(key === 'buy_cmp_info_nm' && !item[key]){
            warnMsg = '매입처를 입력해주세요.'
            prodFlag = true
          return prodFlag
          }
          if(key ==='gpu_model_nm' && !item[key] && checkGPUModel(item['prod_class_id'])){
            warnMsg = 'GPU Model을 입력해주세요'
            prodFlag = true
            return prodFlag
          }
          if(key ==='gpu_model_qty' && item[key] <= 0 && checkGPUModel(item['prod_class_id'])){
            warnMsg = 'GPU 수량을 입력해주세요'
            prodFlag = true
            return prodFlag
          }
        })
      })

      let applicableYn;
      if(state.depthProdList && state.inoutRowData){
          const yList = state.depthProdList.filter(r => r.applicable_yn == 'Y' || r.applicable_yn == 'A')
          applicableYn = checkApplicableLists(yList,state.inoutRowData)
      }

      if(state.inoutParams.tax_dt && state.inoutParams.tax_yn ==='Y' && (state.salesOptyParams.stage_cd.includes('STG03') ||
             state.salesOptyParams.stage_cd.includes('STG04') ||
             state.salesOptyParams.stage_cd.includes('STG05')) && !applicableYn.isApplicable){
        if(!state.salesOptyParams.isp_dt && !state.salesOptyParams.w_end_dt){
          warnMsg = `${applicableYn.productName} 상품이 입력된 경우 검수완료일과 계약만료일은 필수로 입력해야 합니다.`
          prodFlag = true
        }else if(!state.salesOptyParams.isp_dt && state.salesOptyParams.w_end_dt){
          warnMsg = `${applicableYn.productName} 상품이 입력된 경우 검수완료일은 필수로 입력해야 합니다.`
          prodFlag = true
        }else if(state.salesOptyParams.isp_dt && !state.salesOptyParams.w_end_dt){
          warnMsg = `${applicableYn.productName} 상품이 입력된 경우 계약만료일은 필수로 입력해야 합니다.`
          prodFlag = true
        }else{
          if (!applicableYn.hasAMatch) {
            if (state.inoutParams.tax_dt && state.salesOptyParams.isp_dt) {
              const diffIspDt = getDaysDiff(state.inoutParams.tax_dt, state.salesOptyParams.isp_dt);
              if (diffIspDt > 31) {
                prodFlag = true;
                warnMsg = `매출세금계산서일자(${state.inoutParams.tax_dt})와 검수완료일(${state.salesOptyParams.isp_dt})의 날짜 차이가 ±31일 범위를 벗어납니다.`;
              }
            }
            if (state.inoutParams.tax_dt && state.salesOptyParams.w_end_dt) {
              const diffWEndDt = getDaysDiff(state.inoutParams.tax_dt, state.salesOptyParams.w_end_dt);
              const taxDtObj = new Date(state.inoutParams.tax_dt);
              const wEndDtObj = new Date(state.salesOptyParams.w_end_dt);
              if (diffWEndDt > 31) {
                prodFlag = true;
                warnMsg = `매출세금계산서일자(${state.inoutParams.tax_dt})와 계약만료일(${state.salesOptyParams.w_end_dt})의 날짜가 ±31일 범위를 벗어납니다.`;
              }
            }
          } 
        }
      }

      if(prodFlag){
        alert(warnMsg)
        return
      }
      
    }
    
    let saveMsg = '등록하시겠습니까?'
    if(tmpYn === 'Y'){
      saveMsg = '임시저장일 경우 첨부파일은 저장이 안됩니다.임시저장하시겠습니까?'
    }
    if(!confirm(saveMsg)) return

    saveOpty();

    
  }catch(e){
    console.log(e)
    alert('영업기회 저장을 실패했습니다.')
    // routerCmn.routerPush('/sr/MSR_SO_002')
  }
  

}
const getDaysDiff = (date1, date2) => {
  const arbitraryYear = 2000;
  const [year1, month1, day1] = date1.split('-').map(Number);
  const d1 = new Date(arbitraryYear, month1 - 1, day1);
  const [year2, month2, day2] = date2.split('-').map(Number);
  const d2 = new Date(arbitraryYear, month2 - 1, day2);

  const diffTime = Math.abs(d2.getTime() - d1.getTime());
  const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
  return diffDays;
};

const saveOpty = async() =>{

  //복사등록,임시저장일때는 첨부파일 저장x
  if(state.salesOptyParams.tmp_yn === 'N'){
    state.captionTbId = 'sales'
    state.salesOptyParams.tb_id = 'sales'
    let tmpFiles = fileUploadRef.value.state.tmpFileList;
    //임시파일이 있으면 실제 경로 저장
    if (tmpFiles.length > 0) {
      await fileUploadRef.value.uploadFile("opty/file");
      return
    }

    if (state.fileList.length > 0) {
      state.salesOptyParams.attachFileVO.file_seq = state.fileList.toString();
    }

    if (state.delFileList.length > 0) {
      state.salesOptyParams.attachFileVO.del_file_seq = state.delFileList.toString();
    }
  }else{
    state.salesOptyParams.tb_id = 'sales_imsi'
    state.captionTbId = 'sales_imsi'
  }

  // 데이터 변환 전에 기존 데이터와 저장 데이터의 변환 여부 판단
  let updFlag = false
  for (const key of Object.keys(state.originalSalesOptyParams)) {
    if (state.originalSalesOptyParams[key] !== state.salesOptyParams[key]) {
      updFlag = true
      break
    }
  }

  if(updFlag){
    state.salesOptyParams.upd_yn = 'Y'
  }
  // if( state.salesOptyParams.w_end_ck == false && (state.salesOptyParams.w_end_dt != null || state.salesOptyParams.w_end_dt !=undefined || state.salesOptyParams.w_end_dt != "")){
  //   state.salesOptyParams.w_end_ck = true
  // }


  //임시저장 -> 수정완료 
  state.salesOptyParams.ims_seq = state.searchOptyParams.ims_seq
  state.salesOptyParams.w_end_ck = state.salesOptyParams.w_end_ck ? 1 : 0
 

  if(state.salesOptyParams.w_end_ck == '1'){
    state.salesOptyParams.w_alarm_yn = 'Y'
  }else{
     state.salesOptyParams.w_alarm_yn = 'N'
  }
    //WARRANTY 매핑 시 알람은 더이상 X
  if(state.salesOptyParams.warMapping){
    state.salesOptyParams.w_alarm_yn = 'N'
  }
  state.salesOptyParams.outcome_sum = outcome_sum.value
  state.salesOptyParams.income_sum = income_sum.value
  state.salesOptyParams.gm_amt = gm_amt.value
  state.salesOptyParams.gm_amt_per = gm_amt_per.value
  //dt format
  if(state.salesOptyParams.tax_dt)state.salesOptyParams.tax_dt = state.salesOptyParams.tax_dt.replaceAll('-','')
  if(state.salesOptyParams.collect_dt)state.salesOptyParams.collect_dt = state.salesOptyParams.collect_dt.replaceAll('-','')
  if(state.salesOptyParams.won_dt)state.salesOptyParams.won_dt = state.salesOptyParams.won_dt.replaceAll('-','')
  if(state.salesOptyParams.po_dt)state.salesOptyParams.po_dt = state.salesOptyParams.po_dt.replaceAll('-','')
  if(state.salesOptyParams.dlv_dt)state.salesOptyParams.dlv_dt = state.salesOptyParams.dlv_dt.replaceAll('-','')
  if(state.salesOptyParams.isp_dt)state.salesOptyParams.isp_dt = state.salesOptyParams.isp_dt.replaceAll('-','')
  if(state.salesOptyParams.w_end_dt)state.salesOptyParams.w_end_dt = state.salesOptyParams.w_end_dt.replaceAll('-','')

  let params = {...state.salesOptyParams}

  params.tmp_yn = state.salesOptyParams.tmp_yn === 'C' ? 'Y' : state.salesOptyParams.tmp_yn
  params.stage_cd = state.salesOptyParams.tmp_yn === 'C' ? '' : params.stage_cd


  //복사등록일때는 매입매출도 새로 등록되어야함으로 SEQ번호 지움
  if(state.salesOptyParams.tmp_yn === 'C'){
    params.sales_id = null
    params.opty_seq = null

  }
    //복사등록 수정완료일때
    params.copy_update = 'Y'

  try { 
    setIsLoading(true)
    const res = await salesOptyEdit(params)
    if(res.code !== '0000'){
      alert('영업기회 저장에 실패했습니다.다시 시도해주세요')
      return
    }
    
   
    //매입매출
    let editInoutList =[];
    for(let item of [...state.inoutRowData]){
      // 업데이트 검사
      if (item.opty_inout_seq != '') { // NewRow가 아닌 것
        // state.originalInoutRowData에 item의 opty_inout_seq와 같은 opty_inout_seq를 가지고 있는 데이터가 있는지 검사
        const sameSeqRow = state.originalInoutRowData.find((originalRow) => originalRow.opty_inout_seq == item.opty_inout_seq);
        if (sameSeqRow) {
          // sameSeqRow와 item의 데이터가 모든 항목에서 다 맞는지 검사
          let updFlag = false; // 동일 여부 플래그
          Object.keys(item).forEach((key) => {
            if(key != 'gm_amt' && key != 'gm_amt_per'){
              if (item[key] !== sameSeqRow[key]) {
                updFlag = true; // 하나라도 다르면 true              
              }
              if(key == 'tax_dt' && item[key] !== state.inoutParams.tax_dt){
                updFlag = true; 
              }
              if(key == 'tax_yn' && item[key] !== state.inoutParams.tax_yn){
                updFlag = true; 
              }
               if(key == 'collect_dt' && item[key] !== state.inoutParams.collect_dt){
                updFlag = true; 
              }
              if(key == 'collect_yn' && item[key] !== state.inoutParams.collect_yn){
                updFlag = true; 
              }
            }
            if(updFlag) return
          });

          // 검사 결과 처리
          if (updFlag) {
            item.upd_yn = 'Y'
          } else {
            item.upd_yn = 'N'
          }
        }
      }
      state.excelHeaderKey.forEach((key)=>{
        if(key.includes('_dt') || key.includes('_yn')){
          if(item[key] === 'N/A' || !item[key]) item[key] = ''
        }
      })

      item.tmp_yn = params.tmp_yn
      if(!item.sales_id){
        item.copy_inset_yn = 'Y'
      }else{
        item.copy_inset_yn = 'N'
      }
      item.sales_id = res.rtn.sales_id
      item.opty_seq = res.rtn.opt_seq || null
      if(params.tmp_yn === 'N'){
        item.opty_inout_seq =  item.opty_inout_seq || ''
        item.tmp_yn = 'N'
      }else{
        //item.opty_inout_seq = ''
        item.ims_seq = res.rtn.ims_seq
        item.tmp_yn = 'Y'
       
      }

      item.tax_sale_dt = item.tax_sale_dt.replaceAll(/-|NaN/gi,'')
      item.pay_dt = item.pay_dt.replaceAll(/-|NaN/gi,'')
      item.tax_dt = state.inoutParams.tax_dt.replaceAll(/-|NaN/gi,'')
      item.collect_dt = state.inoutParams.collect_dt.replaceAll(/-|NaN/gi,'')
      item.tax_yn = state.inoutParams.tax_yn 
      item.collect_yn = state.inoutParams.collect_yn
      item.memo = state.inoutParams.memo
      editInoutList.push(item)
    }

    if(editInoutList?.length > 0){
      const inoutRes = await editInout(editInoutList)
      if(inoutRes.code !== '0000'){
        alert(inoutRes.ex_message ||'매입매출 저장에 실패했습니다.')
        return
      }
    }else{
      alert('매입매출 입력해주세요.')
      return
    }


    //복사등록일때 캡션에 SEQ번호 있으면 업데이트됨으로 공백으로 초기화 그 외는 등록,수정
    state.salesOptyParams.opty_seq = res.rtn.opt_seq || null
    state.salesOptyParams.sales_id = res.rtn.sales_id || null
    //캡션
    let capRes;
    if(state.salesOptyParams.tmp_yn === 'N'){
      if( state.salesOptyParams.opty_seq && state.salesOptyParams.ims_seq){
        let cpcntSeq;
        const delCapRes = await cpCtntDel({tb_id : 'sales_imsi',cap_seq : state.salesOptyParams.ims_seq})
        if(delCapRes.code !== '0000')alert('캡션 임시 데이터 삭제에 실패했습니다.')

        let params = {
          tb_id : 'sales',
          cap_seq : state.salesOptyParams.opty_seq
        }

        const cpcntSelectRes = await cpCtntSelect(params)
        cpcntSeq = cpcntSelectRes.rtn.seq
        captionRef.value.setSeq(null)
        capRes = await captionRef.value.saveCapCtnt(res.rtn.opt_seq,'sales',cpcntSeq)

      }else{
        capRes = await captionRef.value.saveCapCtnt(res.rtn.opt_seq,'sales',state.salesOptyParams.opty_seq)
      }
    }else{
      capRes = await captionRef.value.saveTempCapCtnt(res.rtn.ims_seq,'sales_imsi')
    }
    
    if(capRes.code !== '0000'){
      alert('캡션 저장에 실패했습니다.')
      return
    }
    

    
    alert('영업기회 저장에 성공했습니다.')
      
    if(state.salesOptyParams.tmp_yn === 'N'){
      routerCmn.routerPush('/sr/MSR_SO_002')
    }else{
      history.state.ims_seq = res.rtn.ims_seq
      router.go(0)
    }
    
  } catch (err) {
    console.log(err)
    alert('영업기회 저장을 실패했습니다.')
  } finally {
    setIsLoading(false)
  }
}
  
//매입매출 정보 저장
const editInout = async(editInoutList)=>{
  try {
    //삭제 매입매출 api 호출 후 저장
    if(state.salesOptyInoutListVO.length > 0){
      const delRes = await salesOptyInoutListDel({salesOptyInoutListVO:state.salesOptyInoutListVO})
      if(delRes.code !== '0000'){
        alert('매입매출 삭제중 오류가 발생했습니다.')
        return
      }
    }

    let params = {
      salesOptyInoutListVO : editInoutList
    }
    
    return await salesOptyInoutListEdit(params)
  } catch (err) {
    console.error(err)
  }
}


const openOptyModal = async() =>{
  if(state.warMapping == true){
    warrantySalesModalRef.value.openModal()
  }else{
    state.salesOptyParams.w_sales_id = ''
  }
}


const priceToString = (item) => {
    return common.checkNumberComma(item)
}
  
//상세조회
const searchOpty = async() =>{
  try {
    setIsLoading(true)

    const res = await salesOptySelect(state.searchOptyParams)
    if(Object.keys(res.rtn).length === 0){
      alert('조회되는 영업기회가 없습니다.확인 후 다시 조회해주세요.')
      router.push('/sr/MSR_SO_002')
      return
    }
    Object.assign(state.salesOptyParams, res.rtn);
    if(state.salesOptyParams.w_end_ck == '0'){
      state.salesOptyParams.w_end_ck = false
    }
    if(state.salesOptyParams.w_end_ck ==  '1'){
      state.salesOptyParams.w_end_ck = true
    }
    //str to date (날짜 포멧)
    state.salesOptyParams.sales_id = res.rtn.sales_id
    state.salesOptyParams.iopty_seq = res.rtn.iopty_seq || null

    if(res.rtn.ims_seq){
      state.salesOptyParams.ims_seq = res.rtn.ims_seq || null
      state.salesOptyParams.opty_seq = res.rtn.iopty_seq || null
      state.captionTbId = 'sales_imsi'
      state.captionSeq = res.rtn.ims_seq
      if(state.salesOptyParams.opty_seq){
        state.searchOptyParams.opty_seq = state.salesOptyParams.opty_seq
      }
    }else{
      state.captionTbId = 'sales'
      state.salesOptyParams.opty_seq = res.rtn.opty_seq || null
      state.captionSeq = res.rtn.opty_seq
    }

    state.salesOptyParams.sales_id = res.rtn.sales_id
    state.salesOptyParams.tax_dt =    res.rtn.tax_dt ? common.dateFormat(new Date(res.rtn.tax_dt.replaceAll('KST','')))  : ''
    state.salesOptyParams.collect_dt = res.rtn.collect_dt ? common.dateFormat(new Date(res.rtn.collect_dt.replaceAll('KST',''))) : ''
    state.salesOptyParams.reg_dt = res.rtn.reg_dt ? common.dateFormat(new Date(res.rtn.fmt_reg_dt.replaceAll('KST',''))) : ''
    state.salesOptyParams.won_dt = res.rtn.won_dt ? common.dateFormat(new Date(res.rtn.won_dt.replaceAll('KST',''))) : ''
    state.salesOptyParams.dlv_dt = res.rtn.dlv_dt ? common.dateFormat(new Date(res.rtn.dlv_dt.replaceAll('KST',''))) : ''
    state.salesOptyParams.isp_dt = res.rtn.isp_dt ? common.dateFormat(new Date(res.rtn.isp_dt.replaceAll('KST',''))) : ''
    state.salesOptyParams.w_end_dt = res.rtn.w_end_dt ? common.dateFormat(new Date(res.rtn.w_end_dt.replaceAll('KST',''))) : ''
    state.salesOptyParams.po_dt = res.rtn.po_dt ? common.dateFormat(new Date(res.rtn.po_dt.replaceAll('KST',''))) : ''

    if(state.salesOptyParams.w_sales_id) state.warMapping = true

    // 불러온 데이터 그대로 저장 (수정 완료 시에 변경점 체크를 위함)
    state.originalSalesOptyParams = {...state.salesOptyParams}
    //첨부파일이 존재할경우 파일리스트 조회api 호출
    if (res.rtn.file_seq_grp != "" && res.rtn.file_seq_grp != null && res.rtn.file_seq_grp != undefined) {
      let apiParam = {
        file_seq_grp: res.rtn.file_seq_grp,
      };
      try {
        const resFileList = await fileList(apiParam)
        fileUploadRef.value.state.fileParams.fileListVo = resFileList.rtn
        state.resFileList = resFileList.rtn
      } catch (err) {
        console.log("파일리스트 조회 api 에러", error);
        alert("파일리스트 조회에 실패했습니다.");
        throw err
      }
    }
  } catch (err) {
    console.error(err)
    routerCmn.routerPush("/sr/MSR_SO_002");
  } finally {
    setIsLoading(false)
  }
}
//매입매출 정보 그리드 행추가
const addInoutData = ()=>{
  let param = {
    index : state.inoutMaxIndex,
    group : 'New',
    opty_inout_seq : '',
    made_cmp_info_nm : '',
    made_cmp_info_seq : '',
    buy_cmp_info_nm : '',
    buy_cmp_info_seq : '',
    prod_rev_id : state.recentProdRev,
    prod_class_id : '',
    gpu_model_nm : '',
    gpu_model_qty : 0,
    outcome_sum : 0,
    income_sum : 0,

    tax_dt : '',
    tax_yn : '',
    collect_dt : '',
    pay_yn:'',

    ins_yn : '',
    tax_sale_yn : '',
    tax_sale_dt : '',
    purchase_yn : '',
    pay_dt : '',
  }
  state.inoutMaxIndex += 1
  state.inoutRowData.push(param)
}

const clickMemoOpenDialog = (value) =>{
  const {key,target,title} = value
  DialogMemoTextRef.value.openDialog(key,target,title)
}

const getCancel = (item) => {
   //세금계산서 발행이 y -> n 으로 변경될때 알랏창
    if(item.cd_id === 'N'){
      state.inoutParams.tax_yn ='N'
      state.cancelflag = true
      DialogMemoTextRef.value.openDialog('text',state.inoutParams.memo,'세금계산서발행이 취소처리 되었습니다. 사유를 입력하세요');
    }else if(item.cd_id === 'Y'){
      state.inoutParams.tax_yn ='Y'
      state.cancelflag = false
    }else{
      state.inoutParams.tax_yn =''
      state.cancelflag = false
    }
  return  state.inoutParams.tax_yn
}

const onCellEditComplete = (event)=>{
  let { data,value ,newValue, newData, field } = event;
  selectRowIndex.index = data.index;
  if(field === 'tax_yn'){
    state.inoutRowData[data.index].tax_yn = newValue
  }
  if(field !== 'made_cmp_info_nm' && field !== 'buy_cmp_info' && field !== 'class_id' && !field.includes('class_nm')){

    if(field === 'tax_dt'){
      if(data['collect_dt'] && newValue > data['collect_dt']){
        alert('수금일은 매출세금계산서 발행일보다 빠를 수 없습니다.수금일을 다시 입력해주세요.')
        data['collect_dt'] = null
      }
    }else if(field === 'tax_sale_dt'){
      if(data['pay_dt'] && newValue > data['pay_dt']){
        alert('지급일은 매입 세금계산서 발행일보다 빠를 수 없습니다.지급일을 다시 입력해주세요.')
        data['pay_dt'] = null
      }
    }

    if(field.includes('_dt')){
      data[field] = newValue
    }

    if(field === 'outcome_sum' || field === 'income_sum')
     newValue = isNaN(Number(newValue)) ? newValue.replace(/,/g, '') : Number(newValue)
    


    if(field !== 'memo'){
      data[field] = newValue;
      state.inoutRowData[data.index][field] = newValue
    }
    getGMandGMper();
    searchInoutList();
  }
}



//상품 모달 open
const openProdModal = (val)=>{
  state.clickKey.index = val.index

  prodClassModalRef.value.openModal()
}
  
const deleteInoutData = async ()=>{
  if(!confirm('정말 삭제하시겠습니까?')) return
  try {
    let params = {
      deleteIndex : []
    }

    for(let item of state.inoutSelectedRow){
      //db에 있는 데이터 추출
      if(item.opty_inout_seq){
        state.salesOptyInoutListVO.push({
          sales_id : item.sales_id,
          opty_inout_seq :item.opty_inout_seq,
          ims_seq : state.searchOptyParams.ims_seq, 
          made_cmp_info_nm : item.made_cmp_info_nm,
          made_cmp_info_seq : item.made_cmp_info_seq,
          buy_cmp_info_nm : item.buy_cmp_info_nm,
          buy_cmp_info_seq : item.buy_cmp_info_seq,
          prod_rev_id : item.prod_rev_id,
          prod_class_id : item.prod_class_id,
          outcome_sum : item.outcome_sum,
          income_sum : item.income_sum,
          tax_dt : item.tax_dt == 'N/A'?null :item.tax_dt.replaceAll(/-|NaN/gi,''),
          tax_yn : item.tax_yn == 'N/A'?null : item.tax_yn,
          collect_dt : item.collect_dt == 'N/A'?null:item.collect_dt.replaceAll(/-|NaN/gi,''),
          pay_yn:item.pay_yn== 'N/A'?null:item.pay_yn,
          ins_yn : item.ins_yn,
          tax_sale_yn : item.tax_sale_yn== 'N/A'?null:item.tax_sale_yn,
          tax_sale_dt : item.tax_sale_dt == 'N/A'?null :item.tax_sale_dt.replaceAll(/-|NaN/gi,''),
          purchase_yn : item.purchase_yn,
          pay_dt : item.pay_dt=='N/A'? null:item.pay_dt.replaceAll(/-|NaN/gi,''),
          upd_id : item.upd_id,
          collect_yn : item.collect_yn =='N/A'? null:item.collect_yn,
          memo : item.memo,
          opty_seq: item.opty_seq,
          reg_id: item.reg_id
          || null})
      }
      params.deleteIndex.push(item.index)
    }
 



    state.inoutRowData = state.inoutRowData
      .filter(inoutData => !params.deleteIndex.includes(inoutData.index))
      .map((newInoutData, newIndex) => ({
        ...newInoutData,
        index: newIndex
      }));
    state.inoutMaxIndex = state.inoutRowData.length;

  } catch (err) {
    console.error(err)
    alert('매입매출 삭제중 오류가 발생했습니다.')
  } finally {
    state.inoutSelectedRow = []
  }
  
    
  
}
  
//매입매출 목록 다운로드
const inoutExcelDown = ()=>{
  let fileNm = '매입매출 목록'
  let inoutList = state.inoutRowData;

  let header = [
    {header : '매입매출 그룹', key:'group'},
    {header : '제조사',key:'made_cmp_info_nm'},
    {header : '매입처',key:'buy_cmp_info_nm'},
    {header : '상품 1단계' ,  key : 'class_nm1'},
    {header : '상품 2단계' ,  key : 'class_nm2'},
    {header : '상품 3단계' ,  key : 'class_nm3'},
    {header : '매출금액(원)' ,key:'outcome_sum'},
    {header : '매입금액(원)' , key:'income_sum'},
    {header : 'Gross Margin' , key:'gm_amt'},
    {header : 'GM(%)' , key:'gm_amt_per'},
    {header : '매입세금계산서 발행일' ,key:'tax_sale_dt'},
    {header : '매입여부' ,key:'tax_sale_yn'},
    {header : '지급일' ,key:'pay_dt'},
    {header : '지급여부' ,key:'pay_yn'},
  ];

  if(state.gpumodelYn){
    header = [
      {header : '매입매출 그룹', key:'group'},
      {header : '제조사',key:'made_cmp_info_nm'},
      {header : '매입처',key:'buy_cmp_info_nm'},
      {header : '상품 1단계' ,  key : 'class_nm1'},
      {header : '상품 2단계' ,  key : 'class_nm2'},
      {header : '상품 3단계' ,  key : 'class_nm3'},
      {header : 'GPU Model' , key:'gpu_model_nm'},
      {header : 'GPU 수량' , key:'gpu_model_qty'},
      {header : '매출금액(원)' ,key:'outcome_sum'},
      {header : '매입금액(원)' , key:'income_sum'},
      {header : 'Gross Margin' , key:'gm_amt'},
      {header : 'GM(%)' , key:'gm_amt_per'},
      {header : '매입세금계산서 발행일' ,key:'tax_sale_dt'},
      {header : '매입여부' ,key:'tax_sale_yn'},
      {header : '지급일' ,key:'pay_dt'},
      {header : '지급여부' ,key:'pay_yn'},
    ];
  }
  let headerProps = header.map((item)=>{
    return item.key
  })
  excelManageRef.value.excelDownload(fileNm,header,inoutList,headerProps)
}

function downTemplateInout(){
  if(confirm('템플릿을 다운 받으시겠습니까?')){
    let header = [
      {header : '제조사',field:'made_cmp_info_nm'},
      {header : '매입처',field:'buy_cmp_info_nm'},
      {header : '상품',field:'class_nm'},
      {header : '매출금액(원)',field:'outcome_sum'},
      {header : '매입금액(원)',field:'income_sum'},
      {header : '매출세금계산서 발행일(yyyy-mm-dd)',field:'tax_dt'},
      {header : '발행여부',field:'tax_yn'},
      {header : '수금일(yyyy-mm-dd)',field:'collect_dt'},
      {header : '수금여부',field:'collect_yn'},
      {header : '매입세금계산서 발행일(yyyy-mm-dd)',field:'tax_sale_dt'},
      {header : '매입여부',field:'tax_sale_yn'},
      {header : '지급일(yyyy-mm-dd)',field:'pay_dt'},
      {header : '지급여부',field:'pay_yn'},
    ]
    //샘플데이터
    let dataList = [
      { made_cmp_info_nm: 'CP-0000001013',
        buy_cmp_info_nm: 'CP-0000001001',
        class_nm: 'A001A003A001',
        outcome_sum: '10000',
        income_sum: '10000',
        tax_dt: '2024-05-08',
        tax_yn: 'Y',
        collect_dt: '2024-05-08',
        collect_yn: 'Y',
        tax_sale_dt: '2024-05-08',
        tax_sale_yn: 'Y',
        pay_dt: '2024-05-08',
        pay_yn: 'Y',
      },
    ]
    excelManageRef.value.excelDownload('매입매출 템플릿',header,dataList)
  }
}
//excelupload click
const selectUploadFile = ()=>{
    excelManageRef.value.selectUploadFile()
}

//get upload File
const getExcelData = async(excelData) =>{
  try{
    let offset = 9*60*60 * 1000;

    const cmpRes = await searchCmpList({page_count : 1,unit_count : 999999})
    const cmpList = [...cmpRes.rtn]

    const prodRes = await searchProdList()
    const prodList = [...prodRes.rtn]
    const dateFormatRegex = /^\d{4}-\d{2}-\d{2}$/;
    let excelList = []

    const incorrectCol = {
      nullCell : false,
      nanCol : false,
      prodIncorrect : false, 
      notDateFormat : false,
      dateConditionTax : false,
      dateConditionTaxSale : false,
      notYn : false
    }

    let incorrectIdx = null
    excelData[0].some((item,index)=>{
      let incoreect = false
      item.index = state.inoutMaxIndex
      state.inoutMaxIndex += 1 
      state.excelHeaderKey.some((key)=>{
        if(item[key]){

          //회사관리번호 매핑해서 이름으로 보여주기
          if(key === 'made_cmp_info' || key === 'buy_cmp_info'){
            let cmp = cmpList.find((cmp)=>cmp.cmp_info_seq === item[key])

            if(cmp){
              let cmp_nm = cmp['cmp_nm']
              item[`${key}_seq`] = item[key]
              item[`${key}_nm`] = cmp_nm
            }
          }

          //상품코드를 상품명으로 보여주기
          if(key === 'class_id'){
            if(item[key]?.length < 12){
              incoreect = true
              incorrectCol.prodIncorrect = true
            }else{
              let prodFam = common.findUperCode(item[key],prodList)
              if(prodFam.length > 0){
                item['prod_class_id'] = item[key]
                item['prod_rev_id'] = state.maxRev
                item['prod_level'] = prodFam.length
                //createInoutCol(prodFam)
                prodFam.forEach((prod,index)=>{
                  item[`class_nm${index+1}`] = prod.class_nm
                })
              }
            }
          }
          //매입,매출 금액 숫자 데이터인지 체크
          if(key.includes('_sum')){
            incoreect = isNaN(Number(item[key]))
            if(isNaN(Number(item[key]))){
              incorrectCol.nanCol = true
            }
          }

          //엑셀 날짜 데이터들은 utc 기준이라 kst시간대로 +9시간 맞추기
          if(key.includes('_dt')){
            if(item[key] instanceof Date){
              item[key] = common.dateFormat(new Date(item[key].getTime() + offset))
              if (!dateFormatRegex.test(item[key])) {
                incoreect = true
                incorrectCol.notDateFormat = true
              }
            }else{
              incoreect = true
              incorrectCol.notDateFormat = true
            }
          }
        
          //여부 컬럼에 y,n 값 외 입력됐을 경우 막기
          if(key === 'tax_yn' || key === 'collect_yn' ||key === 'tax_sale_yn' ||key === 'pay_yn'){
            if(item[key]){
              if(item[key] !== 'y' && item[key] !== 'Y' && item[key] !== 'n' && item[key] !== 'N'){
                incorrectCol.notYn = true
                incoreect = true
              }else{
                item[key] = item[key] ? item[key].toUpperCase() : item[key]
              }
            }
          }
        }else{
          if([state.inoutKey].includes(key)){
            incoreect = true
            incorrectCol.nullCell = true
          }
        }
        return incoreect
      })

      if(!incorrectCol.notDateFormat){
        //2025-03-27
        // 매출세금계산서 발행일 <= 수금일 조건
        // if(item['tax_dt'] && item['collect_dt']){
        //   if(item['tax_dt'] > item['collect_dt']) {
        //     incoreect = true
        //     incorrectCol.dateConditionTax = true
        //   }
        // }

        //매입세금계산서 발행일 <= 지급일 조건
        if(item['tax_sale_dt'] && item['pay_dt']){
          if(item['tax_sale_dt'] > item['pay_dt']) {
            incoreect = true
            incorrectCol.dateConditionTaxSale = true
          }
        }
      }

      if(!incoreect) {
        excelList.push(item)
      }else{
        incorrectIdx = index
      }
      
      return incoreect
    })

    let notUpload = false
    for(let flag in incorrectCol){
      if(incorrectCol[flag]){
        notUpload = incorrectCol[flag]
        break;
      }
    }

    if(!notUpload){
      for(let inoutData of excelList){
        state.inoutRowData.push(inoutData)
      }
      alert(`${excelList.length}건 완료했습니다.`)
      alert('영업기회 저장 후에 반영 데이터입니다.\n저장하지 않을 경우 등록하신 매입매출은 저장되지 않습니다.')
      getGMandGMper();
      searchInoutList();
    }else{
      let msg = ''
      Object.keys(incorrectCol).some((key)=>{
        switch(key){
          case 'nullCell' :
            if(incorrectCol[key]) msg = '필수값이 누락된 셀이 있습니다.\n'
          break;
          case 'prodIncorrect' :
            if(incorrectCol[key]) msg = '3단계가 아닌 상품분류체계가 있습니다.\n'
          break;
          case 'nanCol' :
            if(incorrectCol[key]) msg = '숫자 형식이 아닌 데이터가 있습니다.\n'
          break;
          case 'notDateFormat' :
            if(incorrectCol[key]) msg = '날짜 형식이 아닌 셀이 있습니다.\n'
          break;
          // case 'dateConditionTax' :
          //   if(incorrectCol[key]) msg = '수금일이 매출세금계산서 발행일보다 빠릅니다.\n'
          // break;
          case 'dateConditionTaxSale' :
            if(incorrectCol[key]) msg = '지급일이 매입세금계산서 발행일보다 빠릅니다.\n'
          break;
          case 'notYn' :
            if(incorrectCol[key]) msg = '여부관련 값에 맞지 않는 값이 있습니다.\n'
          break;
        }
      })
      alert(`${incorrectIdx+2}번째 행에\n${msg}확인 후 다시 업로드해주세요.`)
    }

  }catch(e){
    alert('엑셀 업로드에 실패했습니다.파일을 확인 후 다시 업로드해주세요.')
  }
  
}

function numberFomat(number){
  if(number){
    return number = common.checkNumberComma(number)
  }
  return number
}

function getCodeNm(val){
  if(!val){
    return '-'
  }
  if(val){
    const getCodeNNm = codeStore.getCodeNm('GPU_MODEL_CD',val)
    return getCodeNNm.cd_nm
  } 
}

async function searchCmpList(params){
  try{
    setIsLoading(true)
    const res = await compList(params)
    return res
  }catch(e){
    console.log(e)
  }finally{
    setIsLoading(false)
  }
}



async function searchProdList(){
  try{
    setIsLoading(true)
    const prodRes = await prodList({rev_id : state.maxRev})
    state.prodRevId = prodRes.rtn[0].rev_id
    return prodRes
  }catch(e){
    console.log(e)
  }finally{
    setIsLoading(false)
  }
}


async function downloadCmpExcel(){
  try{
    setIsLoading(true)
    let params = {
      page_count : 1,
      unit_count : 999999
    }
    const res = await searchCmpList(params)

    let fileNm = '회사 목록'
    let cmpList = [...res.rtn]
    let header = [
      {header : '회사명',field:'cmp_nm'},
      {header : '부서명',field:'cmp_dvsn_nm'},
      {header : '회사관리번호' ,field:'cmp_info_seq'},
    ];
    excelManageRef.value.excelDownload(fileNm,header,cmpList)
  }catch(e){
    console.log(e)
  }finally{
    setIsLoading(false)
  }
}

async function getProdRevId(){
  try{
    setIsLoading(true)
    const revRes = await getProdRevIDYearList()
    if(state.inoutParams.tax_dt){
      const fs_year = state.inoutParams.tax_dt.substring(0,4)
      state.maxRev = getRevIdByYear(fs_year, revRes.rtn)

    }else{
      revRes.rtn.forEach((item)=>{
        if(item.rev_id > state.maxRev) state.maxRev = item.rev_id
      })
    }
    let params = {
      rev_id: state.maxRev, // 리비전 ID 필수값
    };

    const res = await depthProdList(params)
    state.depthProdList = [...res.rtn]
    state.gpu_model_prod_list = res.rtn.filter(r=> r.gpu_model_yn ==='Y')
    const hasAnyGpuModel = state.inoutRowData.some(item => 
        state.gpu_model_prod_list.some(gpu => gpu.class_Id === item.prod_class_id)
    );
    state.gpumodelYn = hasAnyGpuModel;
    state.inoutGridColumn.forEach(column => {
      if (column.field === 'gpu_model_nm' || column.field === 'gpu_model_qty') {
          column.visible = hasAnyGpuModel;
      }
    });
  return [...res.rtn]
  }catch(e){
    console.log(e)
  }finally{
    setIsLoading(false)
  }
}

function getRevIdByYear(yearToFind, dataList) {
  const foundItem = dataList.find(item => {
    if (typeof item.quota_year === 'string' && item.quota_year.length > 0) {
      
        const years = item.quota_year.split(',');
        return years.includes(yearToFind);
    }
    return false;
  });
  return foundItem ? foundItem.rev_id : null;
}

// async function downloadProdExcel(){
// try{
//     setIsLoading(true)

//     const prodRes = await searchProdList()

//     let fileNm = '상품 목록'
//     let prodClsList = [...prodRes.rtn]
//     let header = [state.excelGridColumn1,[]];
//     let headerProps = []

//     let tmpHeaderProps = [
//       "rev_id",
//       "class_id",
//       "enable_yn",
      
//     ]
//     let maxDepth = 3
//     let param = {
//       rev_id: prodRes.rtn[0].rev_id,
//     };
//     const res = await prodList(param)
//     state.prodList = [...res.rtn]
//     const prodDataList = [...res.rtn].map((item)=>{
//       let codeFam = common.findUperCode(item.class_id,[...res.rtn]) || []
//       if(codeFam.length > 0){
//         codeFam.forEach((itemCode, index) =>
//           item[`class_nm${index + 1}`] = itemCode.class_nm 
//         )
//         if(codeFam.length > maxDepth) maxDepth = codeFam.length
//         return item
//       }
//     });

//     const rootList = []

//     prodDataList.filter(item => item.up_class_id === '').forEach((parentItem)=>{
//       let row = {
//         key: parentItem['class_id'],
//         data: parentItem,
//       };
//       rootList.push(row);
      
//     })
//     rearrange(rootList)

//     rootList.forEach((data)=>{
//       state.excelData.push(data.data)
//       if(data.children?.length > 0){
//         findChildren(data.children)
//       }
//     })

//     function findChildren(childList){
//       [...childList].forEach((child)=>{
//         state.excelData.push(child.data)
//         if(child.children?.length > 0){
//           findChildren(child.children)
//         }
//       })
//     }

//     for(var i=1; i<=maxDepth; i++){
//       headerProps.push(`class_nm${i}`)
//       header[1].push({header : `${i}단계`,rowspan : 1,colspan : 1})
//     }
//     headerProps = [...headerProps,...tmpHeaderProps]
//     header[0].colspan = maxDepth


//     excelManageRef.value.excelDownload(fileNm, [...header], [...state.excelData],[...headerProps])

//   }catch(e){
//     console.log(e)
//   }finally{
//     setIsLoading(false)
//   }
// }

//child depth 계속 생성
const rearrange = (rootList) => {
    rootList.forEach((item)=>{
      let childTree = [];
      state.prodList.forEach((i) => {
        if (i.up_class_id === item.key) {
          let row = {
            key: i.class_id,
            data: i,
          };
          childTree.push(row);
        }
      });

      if (childTree?.length > 0) {
        item.children = childTree;
        rearrange(childTree);
      }
    })
};
// function formCheck(rowData){
//   return rowData.incorrectCol ? 'text-b-rt' : ''
// }
function getMngData(mngData){
  state.salesOptyParams[state.clickKey.key] = mngData.mngr_nm
}

function moveToPage(url,msg,params){
  if(msg){
    if(!confirm(msg)) return
  }
  
  if(params){
      router.push({
          path : path,
          state : params
      })

  }else{
      router.push(url)
  }
}

const setGroupName = (item, key) => {
    if (state.optyInoutGroupList && Object.keys(state.optyInoutGroupList).length === 0) {
      state.groupName = 'A'      
    }else{
      state.groupName = incrementGroupName(state.groupName)
    }

    state.optyInoutGroupList.push({
        seq: item[key],
        value: state.groupName,
    });
    return state.groupName
};

const incrementGroupName = (groupName) => {
    // Z까지 도달하면 길이를 증가시키는 로직
    const isAllZ = groupName.split('').every(char => char === 'Z')
    if (isAllZ) {
        return 'A'.repeat(groupName.length + 1)
    }

    // 뒤에서부터 알파벳을 증가시키는 로직
    const chars = groupName.split('')
    for (let i = chars.length - 1; i >= 0; i--) {
        if (chars[i] === 'Z') {
            chars[i] = 'A'
        } else {
            chars[i] = String.fromCharCode(chars[i].charCodeAt(0) + 1)
            break
        }
    }
    return chars.join('');
};

</script>
    

<style scoped>
.class-nm{
  display:inline-block;
  height: 20px; 
  width:100px;
  cursor: pointer;
}
.cmp-nm{
  display:inline-block;
  height: 20px; 
  width:200px;
  cursor: pointer;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
}
</style>